import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class TreeSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'tree');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        
        return [

            this.backgroundColorField('background.color', ['content']),

            this.fontColorComboField('icon.color', ['main', 'content'], { ...this.preset('icon-color', 'main'), [this.translateValue('INHERIT')]: 'inherit' }),

            this.fontColorComboField('active.font.color', ['main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.backgroundColorField('active.background.color', ['table', 'content'], this.preset('active-background-color', 'main')),
            this.sizeNumberField('active.border.radius', 'px'),
            this.fontColorComboField('hover.font.color', ['main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['tree', 'content'], this.preset('hover-background-color', 'main')),
            
        ];
    }

}
